import React, { useState, useEffect } from "react";
import { IoMdCalendar } from "react-icons/io";
import { FaRegClock } from "react-icons/fa";

const TopNav = () => {
  const [dateTime, setDateTime] = useState({
    date: "",
    time: "",
  });

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      
      // Format date: DD Month YYYY
      const options = { day: "2-digit", month: "long", year: "numeric" };
      const formattedDate = now.toLocaleDateString("en-US", options);
      
      // Format time: HH:MM:SS
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      const formattedTime = `${hours}:${minutes}:${seconds}`;

      setDateTime({
        date: formattedDate,
        time: formattedTime,
      });
    };

    updateDateTime();
    const interval = setInterval(updateDateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <nav className="top_nav">
      <div className="top_nav_container">
        <div className="top_nav_datetime">
        <IoMdCalendar size={20} />
          <span>{dateTime.date}</span>
          <div
            style={{
                width: "1px",
                height: "1.25rem",
                margin: "0 .5rem",
                backgroundColor: "#ccc",
                opacity: 0.75,
            }}
          />

            <FaRegClock size={16} />
          <span>{dateTime.time}</span>
        </div>
      </div>
    </nav>
  );
};

export default TopNav;